module.exports = __webpack_public_path__ + "static/cdl_logo-cc1a1e0ae54e2c5c024f5c231782ca6c.png";